import { toZonedTime } from 'date-fns-tz';

export interface DisableDateOptions {
  timeZone: string;
  startDatetimeThreshold?: Date;
  endDatetimeThreshold?: Date;
  dateLimit?: 'past' | 'future' | 'all';
}

/**
 * Determines whether a calendar date should be disabled.
 * Compares at day level only — thresholds with time components
 * do not prevent selecting the same calendar day.
 */
export function shouldDisableDate(
  zonedDateToCheck: Date,
  {
    timeZone,
    startDatetimeThreshold,
    endDatetimeThreshold,
    dateLimit = 'all',
  }: DisableDateOptions,
): boolean {
  const today = new Date();
  const zonedToday = toZonedTime(today, timeZone);
  zonedToday.setHours(0, 0, 0, 0);

  if (startDatetimeThreshold) {
    const startDay = new Date(startDatetimeThreshold);
    startDay.setHours(0, 0, 0, 0);
    if (zonedDateToCheck < startDay) return true;
  }
  if (endDatetimeThreshold) {
    const endDay = new Date(endDatetimeThreshold);
    endDay.setHours(0, 0, 0, 0);
    if (zonedDateToCheck > endDay) return true;
  }

  switch (dateLimit) {
    case 'past':
      return zonedDateToCheck > zonedToday;
    case 'future':
      return zonedDateToCheck < zonedToday;
    case 'all':
    default:
      return false;
  }
}
